// extracted by mini-css-extract-plugin
export var authorBioEditorialAbout = "K_cm";
export var authorBioEditorialContainer = "K_cl";
export var authorBioEditorialXp = "K_cn";
export var authorBioPageContainer = "K_ck";
export var relatedArticles = "K_R";